<template lang="pug">
include /../../s-pug/mixin-icon
include /pug/mixin-profileEdit--openingListItem
//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
div
   .Underlay._fixed._alpha-80._radius._cursor-default
   .JobViewer-outterContainer
      //- Heading
      ._px075._py075._flex._flex-alignItemsCenter._boxShadow._z50
         ._flex-1
            ._c-grey-800._fs-3._bold._mb025 {{ opening.heading }}
            ._c-grey-600._fs-1._bold at {{ company.name }}
         ._flex._flex-alignItemsCenter
            router-link.Btn.Btn--white._p025._mr05(v-if="!isPreviewMode" :to=`{ path: $router.currentRoute.path }` style="width: 40px; height: 40px; font-weight: 400" type="button")
               +icon({grow: true, name: "icon-x"})._c-grey-800
            button.Btn.Btn--white._px1._mr05(v-if="isPreviewMode" @click="$emit('previewClose')" style="height: 40px; font-weight: 400" type="button")
               | Exit preview
      //- Body
      ._overflowScrollY._customScrollBars._flex-1(ref="jobDescriptionScrollContainer")
         ._px075._py1
            +profileEdit-openingListItem({isInJobViewer: true})
            //- Job details
            ._mb2._mt05
               //- Primary roles
               ._mb05._flex
                  ._c-grey-500._fs-05._mr05 Primary role{{opening.primaryRoles.length > 1 ? '(s)' : ''}}: 
                  ._fs-05._mr025(v-for="(roleOptionKey, index) in opening.primaryRoles") {{ getAttrPropByOptionKey({attrSrc: attrs.primaryRoles, optionKey: roleOptionKey }) }}{{opening.primaryRoles.length > 1 && index !== opening.primaryRoles.length - 1 ? ',' : ''}}
               //- Experience level considered/desired
               ._mb05._flex
                  ._c-grey-500._fs-05._mr05 Experience level{{opening.primaryRoles.length > 1 ? '(s)' : ''}} (considered/desired): 
                  ._fs-05._mr025(v-for="(optionKey, index) in opening.experienceLevel") {{ getAttrPropByOptionKey({attrSrc: attrs.experienceLevel, optionKey: optionKey }) }}{{opening.experienceLevel.length > 1 && index !== opening.experienceLevel.length - 1 ? ',' : ''}}
               //- Primary technologies
               ._flex
                  ._c-grey-500._fs-05._mr05 Tech: 
                  ._fs-05._mr025(v-for="(techOptionKey, index) in opening.tech") {{ getAttrPropByOptionKey({attrSrc: attrs.jobTech, optionKey: techOptionKey, prop: 'name'}) }}{{opening.tech.length > 1 && index !== opening.tech.length - 1 ? ',' : ''}}
                  //- ._c-blue-800
                     span._px05._py025._radius._bg-blue-050._border._borderColor-blue-100._mr025._fs-05(v-for="techOptionKey in opening.tech") {{ getAttrPropByOptionKey({attrSrc: attrs.jobTech, optionKey: techOptionKey, prop: 'name'}) }}
            .JobViewer-longformContent
               div(v-html="opening.onSiteDescription.html")
</template>

<style lang="sass">
</style>

<script>
// modules
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
// data files
import dataCountriesByContinent from '~/../../s-dataStatic/countries-by-continent.json'
import timezonesUTC from '~/../../s-dataStatic/timezonesUTC.json'
import currencies from '~/../../s-dataStatic/currencies.json'
// attrs
import attrsRemote from '~/../../s-dataStatic/attrs-remote.yaml'
import attrsBenefits from '~/../../s-dataStatic/attrs-benefits.yaml'
import attrsJobTech from '~/../../s-dataStatic/attrs-openingJobTech.yaml'
import attrsPositionRole from '~/../../s-dataStatic/attrs-openingJobRole.yaml'
import attrsExperienceLevel from '~/../../s-dataStatic/attrs-openingExperienceLevel.yaml'
import attrsOpeningNextStepCTA from '~/../../s-dataStatic/attrs-openingNextStepCTA.yaml'
import attrsOpeningJobType from '~/../../s-dataStatic/attrs-openingJobType.yaml'
import attrsLocation from '~/../../s-dataStatic/attrs-location.yaml'
import attrsTimezone from '~/../../s-dataStatic/attrs-timezone.yaml'
import attrsQaPrimary from '~/../../s-dataStatic/attrs-qaPrimary.yaml'

export default {
   name: 'JobViewer',
   props: {
      opening: Object,
      company: Object,
      isPreviewMode: Boolean,
   },
   staticData() {
      // This is purely a read-only array of objects so there's no need to have it be "reactive", which
      // it would be if it was stored on the `data` object (the thinking here is that this keeps the memory usage lower... need to look further into this)
      return {
         currencies,
         attrs: {
            remoteDegree: attrsRemote,
            benefits: attrsBenefits,
            jobTech: attrsJobTech,
            experienceLevel: attrsExperienceLevel,
            primaryRoles: attrsPositionRole,
            openingNextStepCTA: attrsOpeningNextStepCTA,
            openingJobType: attrsOpeningJobType,
            location: attrsLocation,
            timezone: attrsTimezone,
            qaPrimary: attrsQaPrimary
         },
      }
   },
   data() {
      return {
         timezonesUTC,
         dataWorkFromLocation: dataCountriesByContinent,
      }
   },
   methods: {
      getAttrPropByOptionKey({ attrSrc, optionKey, prop = 'label' }) {
         if (!attrSrc) return
         const attr = attrSrc.find(attr => attr.optionKey === optionKey)
         return attr && attr[prop]
      },
      getAttrPropByAttrKey({ attrSrc, attrKey, prop = 'label' }) {
         if (!attrSrc) return
         const attr = attrSrc.find(attr => attr.attrKey === attrKey)
         return attr && attr[prop]
      },
      qaPrimarySelectToAdd(item, index) {
         this.qaPrimarySlideoutState.adding.attrKey = item.attrKey
         this.qaPrimarySlideoutState.step = 2
      },
      maybeFocusRangeMaxOnToggle() {
         this.$nextTick(() => this.$refs.jsFocusTargetOnChangeToRangeTrue && this.$refs.jsFocusTargetOnChangeToRangeTrue.focus())
      },
   },
   mounted() {
      disableBodyScroll(this.$refs.jobDescriptionScrollContainer, {
         reserveScrollBarGap: true,
      })
   },
   beforeDestroy() {
      enableBodyScroll(this.$refs.jobDescriptionScrollContainer)
   },
}
</script>
